import { extractCogQuery } from '@/utils/titilerRasterProfile';
import type { GeoreferenceCorners } from './georeferenceTypes';
import { readGeoreference } from './georeferenceTypes';

export function georeferencePreviewUrl(tilesUrl: string | null | undefined): string | null {
  if (!tilesUrl) return null;
  const parts = extractCogQuery(tilesUrl);
  if (!parts) return null;
  return `${parts.base}/cog/preview.png?url=${parts.cogParam}&max_size=2048`;
}

export function georeferenceTileJsonUrl(tilesUrl: string | null | undefined): string | null {
  if (!tilesUrl) return null;
  const parts = extractCogQuery(tilesUrl);
  if (!parts) return null;
  return `${parts.base}/cog/WebMercatorQuad/tilejson.json?url=${parts.cogParam}`;
}

export function readAppliedGeoreferenceCorners(
  layer: { readonly style?: Record<string, unknown> | null } | null | undefined,
): GeoreferenceCorners | null {
  const geo = readGeoreference(layer);
  if (geo?.status !== 'applied' || !geo.corners || geo.corners.length !== 4) return null;
  return geo.corners;
}
